import React, {Component} from "react";
import { TextArea } from "../custom-form/custom-textarea.component";
import ButtonIcon from "../../button";
import Icons from "../../icon";
import { NotificationModal } from "../modal/notification-modal.component";
import CommentList from "./comment-list.component";
import { Allowed_Extension, Conf_Message_Allowed_Extension } from "../../../constants/external-constants";
import Translation from "../../../../app/components/common/translation/translation.component";
import { displayFinalFileName } from "../../../utils/helpers.utils";

class Comment extends Component {
    constructor(props) {
        super(props);
        this.fileRef = React.createRef();
        this.state = {
            inputValue: "",
            fileList: [],
            fileListData: [],
            showModal: false,
            modalMessage: ""
        }
    }

    handleConfirmationModal = () => {
        this.setState(prevState => ({ showModal: !prevState.showModal}));
    }

    handleOnChange = (e) => {
        this.setState({ inputValue: e.target.value })   
    }

    handlePost = () => {
        this.props.addCommentAction(this.state.fileList, this.state.fileListData, this.state.inputValue)
        this.setState({
            inputValue: "",
            fileList: [],
            fileListData: [],
        });
    };

    resetFileInput = () => {
        this.fileRef.current.value = null;
    }

    handleFileChange = (event) => {
        const file = event.target.files[0];
        const filename = file?.name ?? '';
        const extIndex = filename?.lastIndexOf('.') ?? '';
        const newName = filename?.substring(0, Math.min(extIndex, 20)) ?? '';
        const extension = filename?.substring(extIndex + 1) ?? '';
        const finalName = extIndex > 20 ? `${newName}...${extension}` : filename;
        const allowedExtensions = Allowed_Extension;
        const modalMessageExt = Conf_Message_Allowed_Extension;

        if (file) {
            if (file?.size <= 10 * 1024 * 1024) {
                if (this.state.fileList.length <= 2) {
                    if (allowedExtensions.includes(extension)) {
                        this.setState({
                            uploadedFileName: finalName,
                            fileList: [...this.state.fileList, filename],
                            fileListData: [...this.state.fileListData, file]
                        });
                    } else {
                        this.setState({
                            showModal: true,
                            modalMessage: `Only files with the following format are allowed: ${modalMessageExt.map((ext) =>" "+ ext)}`
                        });
                    }
                } else {
                    this.setState({
                        showModal: true,
                        modalMessage: "Number of files exceeds the allowable limit of 3"
                    });
                }
            } else {
                this.setState({
                    showModal: true,
                    modalMessage: "Total file size exceeds the allowable limit of 10 MB"
                });
            }
        }
        else {
            this.setState({
                showModal: false,

            });
        }
        this.resetFileInput();
    };


    deleteAttachInComment(index) {
        this.setState((prevState) => {
            const copyFileList = prevState.fileList.slice();
            const copyFileListData = prevState.fileListData.slice();

            copyFileList.splice(index, 1)
            copyFileListData.splice(index, 1)
            return {
                fileList: copyFileList,
                fileListData: copyFileListData
            }
        })
    }
    
    render() {
        var hasNoComment = this.state.inputValue;
        return (
            <div className="invoice-comment-layout-containers">  
            <div className="invoice-comment-container">  
                <div className="">
                    <div className="file-details-container">
                        <ul className="file-list-container">
                            {this.state.fileList.map((file, index) => (
                                <li className="file-list-item" key={index}>
                                    <div className="file-with-icon-container">
                                        <Icons
                                            customClassName="icon-file-clip"
                                            name="paper-clip-solid"
                                            size="15px"
                                            containerClass="icon-paper-clip-file-container"

                                        />
                                        {displayFinalFileName(file)}
                                    </div>
                                    <span className="delete-files-icon" onClick={() => { this.deleteAttachInComment(index)}}>x</span>
                                </li>
                            ))}
                            </ul>
                            <div>
                                <TextArea customClass="invoice-comment-text invoice-text" label={<Translation translationKey="COMMENT" />} inputValue={this.state.inputValue} maxLength={this.props.maxLength} onChange={(e) => this.handleOnChange(e)} />
                            </div>    
                    </div>
                    {this.props.isReadAndWrite &&
                        <div className="invoice-comment-button-container">
                            <ButtonIcon onClick={() => this.fileRef.current.click()} iconLeft="paper-clip-light" iconSize="17px" isDisable={!hasNoComment} customClassName="header-option-list header-filter-button" labelName="Attach File">
                                <input className="upload-file-btn" type="file" ref={this.fileRef} onChange={this.handleFileChange} />
                            </ButtonIcon>
                                <ButtonIcon onClick={this.handlePost} isDisable={!hasNoComment} customClassName="header-option-list header-filter-button" labelName="Post" />
                        </div>
                    }
                        <CommentList
                            deleteCommentAction={this.props.deleteCommentAction} 
                            commentList={this.props.commentList}
                            noMessage={this.props.noMessage}
                            isEquipment={this.props.isEquipment}
                            isDisputeComment={this.props.isDisputeComment}
                            isInvoiceComment={this.props.isInvoiceComment}
                            isReadOnly={this.props.isReadOnly}
                            isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                            isReadAndWrite={this.props.isReadAndWrite}
                    />
                    </div>
               </div>
                <NotificationModal 
                show={this.state.showModal}
                title={'Confirmation'} 
                customClass={'comment-notification-modal notification-footer'}
                 handleModal={this.handleConfirmationModal}
                message={this.state.modalMessage} />
            </div> 
        );
    }
}

export default Comment;